import React, { useState, useEffect } from "react";
import {
  getAllPartySearch,
  getAllGeneralLedger,
  getAllBank,
} from "../../api/endpoints/search";
import {
  getVoucher,
  getTransactionId,
  saveData,
  getData,
  deleteSingleReceipt,
  deleteReceipt,
  descBank,
  ascBank,
  onePreData,
  oneNextData,
} from "../../api/endpoints/bank.js";

import SideBar from "../sidebar/sideBar";
import "./bankVoucher.css";
import { authSelector } from "../../store/selectors/index";
import { Modal, message } from "antd";
import { Button, Dropdown, Select, Menu } from "antd";
import { useSelector } from "react-redux";
import Popup from "../modals/Popup";
import { latestDate } from "../../api/endpoints/meter.js";
import { EMeters } from "../../enums/meters.js";
import { getSiteRefrence } from "../../api/endpoints/refrences.js";
import { deleteSale, getAlert } from "../../api/endpoints/alert.js";

const { Option } = Select;

const BankVoucher = () => {
  const { user, access_token } = useSelector(authSelector);

  const [voucher, setVoucher] = useState();
  const [voucherType] = useState("BV");
  const [transactionId, setTransactionId] = useState();
  const [type, setType] = useState("ADD");
  const [dateEntered, setDateEntered] = useState("");
  const [shift, setShift] = useState("");
  const [typeLast, setTypeLast] = useState("");
  const [itemsQueue, setItemsQueue] = useState([]);
  const [editedItem, setEditedItem] = useState(null);
  const [fieldsShow, setFieldsShow] = useState(false);
  const [total, setTotal] = useState();
  const [debitTotal, setDebitTotal] = useState();
  const [creditTotal, setCreditTotal] = useState();
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  console.log(type, "type");

  // -------------------------- STATE ----------

  const [state, setState] = useState({
    parties: [],
    allBank: [],
    bankTransactionCode: "",
    bankTransactionOldCode: "",
    bankTransactionDesc: "",
    partyId: "", //ac no.
    partyName: "", // supplier name
    ledgerCodes: [],
    glCode: "",
    glDescription: "",
    description: "",
    invoiceNo: "",
    credit: "",
    cheque: "",
    transactionIdInc: "",
  });

  const clearState = () => {
    setState({
      parties: state.parties,
      allBank: state.allBank,
      bankTransactionCode: "",
      partyId: "",
      partyName: "",
      ledgerCodes: state.ledgerCodes,
      glCode: "",
      glDescription: "",
      description: "",
      invoiceNo: "",
      credit: "",
      debit: "",
      cheque: "",
    });
  };

  const clearStates = () => {
    clearState();
    setEditedItem(null);
    setFieldsShow(false);
    setItemsQueue([]);
    setShift("");
    setDateEntered("");
    setVoucher("");
    setTotal(0);
    setDebitTotal(0);
    setCreditTotal(0);
    setType("ADD");
  };

  const onChangeText = (e, object) => {
    if (object) {
      const { name, value } = object;
      setState({
        ...state,
        [name]: value,
      });
    } else {
      const { name, value } = e.target;
      setState({
        ...state,
        [name]: value,
      });
    }
  };

  // ------------------- ADD VOUCHER ---------------

  const addVoucher = async () => {
    if (!dateEntered) return message.error("Please type date !");
    const payload = {
      enteredOn: dateEntered,
    };
    const result = await getVoucher(payload, access_token);
    const transactionId = await getTransactionId(access_token);
    console.log(result, "result");
    if (result.success) {
      setVoucher(result.data);
      setType("SAVE");
      setFieldsShow(true);
    } else {
      message.error(result.message);
    }
    if (transactionId.success) {
      setTransactionId(transactionId.data);
    }
    console.log(transactionId.data, "trannass");
  };
  // ------------------ SAVE DATA -----------------
  console.log(state, "state-=-=-=");
  console.log(transactionId, "transactionIdState-=-=-=");
  const [allowedShift, setAllowedShift] = useState();
  const getRefrences = async () => {
    const _refrences = await getSiteRefrence(access_token);
    setAllowedShift(_refrences.data.allowedShift);
  };

  useEffect(() => {
    getRefrences();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const save = async () => {
    if (!shift) return message.error("Please type shift!");
    if (shift > allowedShift)
      return message.error(`Your allowed shifts are ${allowedShift}`);
    if (itemsQueue.length === 0) return message.error("Add minimun 1 Entry");
    setIsButtonDisabled(true);

    const payload = itemsQueue.reduce((acc, curr) => {
      return [
        ...acc,
        {
          enteredOn: dateEntered,
          shift: Number(shift),
          partyId: Number(curr.partyId),
          description: curr.description,
          invoiceNumber: curr.invoiceNo,
          generalLedgerCode: curr.glCode,
          bankTransactionCode: curr.bankTransactionCode,
          credit: Number(curr.credit) || 0,
          debit: Number(curr.debit) || 0,
          cheque: curr.cheque,
          transactionId: Number(curr.transactionIdInc),
          voucherNumber: Number(voucher),
          voucherType: voucherType,
          grpId: Number(user.grpId),
          siteId: Number(user.siteId),
          companyCode: Number(user.companyCode),
          approved: user.authorized === true ? true : false,
        },
      ];
    }, []);

    try {
      const result = await saveData(payload, access_token);
      if (result.success) {
        clearStates();
        message.success(result.message || "Successfully entered!");
      } else {
        message.error(result.message || "Failed to save!");
      }
    } catch (error) {
      console.error("Error while saving:", error);
    } finally {
      setIsButtonDisabled(false); // Re-enable the button after the async operation completes

      // Enable the button again, whether the API call succeeds or fails
    }
  };

  // ---------------- ALL ITEMS ----------------

  const getAllData = async () => {
    const _parties = await getAllPartySearch(access_token);
    const _ledgerCodes = await getAllGeneralLedger(access_token);
    const _allBank = await getAllBank(access_token);
    setState({
      ...state,
      parties: _parties,
      ledgerCodes: _ledgerCodes,
      allBank: _allBank,
      bankTransactionOldCode: _allBank[0].generalLedgerCode,
      bankTransactionCode: _allBank[0].generalLedgerCode,
      bankTransactionDesc: _allBank[0].description,
    });
  };
  useEffect(() => {
    getAllData();
    if (itemsQueue.length === 0) return;

    let debitSum = itemsQueue.reduce(
      (arr, curr) => arr + Number(curr?.debit || 0),
      0
    );
    let creditSum = itemsQueue.reduce(
      (arr, curr) => arr + Number(curr?.credit || 0),
      0
    );
    setDebitTotal(Number(debitSum));
    setCreditTotal(Number(creditSum));
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemsQueue]);

  console.log(total, "totttt");

  // ---------------------- ADD ITEM TO QUEUE --------------

  const addItem = () => {
    // Check for required fields
    if (!(state.partyId || state.glCode) || !(state.debit || state.credit) || !state.description) {
      return message.error(
        `Please provide ${
          !(state.partyId || state.glCode)
            ? "account number or GL code"
            : !(state.debit || state.credit)
            ? "debit or credit amount"
            : !state.description
            ? "description"
            : ""
        }`
      );
    } else {
      state.transactionIdInc = transactionId + 1;
      setTransactionId(state.transactionIdInc);
      const uniqueId = Date.now();

      // Create a user entry with the provided data and unique id
      const userEntry = {
        ...state,
        id: uniqueId,
        entryType: state.credit ? "credit" : "debit",
      };

      // Create a bank entry with the corresponding data and unique id
      const bankEntry = {
        ...state,
        id: uniqueId,
        partyId: "", // or set it to the bank's partyId
        partyName: "", // or set it to the bank's partyName
        invoiceNo: "", // or set it to an appropriate value
        cheque: "", // or set it to an appropriate value
        glCode: state.bankTransactionCode,
        entryType: state.credit ? "debit" : "credit",
      };

      // Clear amount fields based on entry type
      if (state.debit) {
        bankEntry.debit = "";
        bankEntry.credit = state.debit; // Clear the credit field in the bank entry
      } else if (state.credit) {
        bankEntry.credit = "";
        bankEntry.debit = state.credit; // Clear the debit field in the bank entry
      }

      // Add both entries to the queue
      setItemsQueue([...itemsQueue, userEntry, bankEntry]);
      const nextInput = inputRefs["accountName"];
      if (nextInput) {
        nextInput.focus();
      }

      clearState();
    }
  };

  console.log(itemsQueue, "items queue-=-=--=");
  const descVoucher = async () => {
    const results = await descBank(access_token);
    console.log(results, "ressaaaaa");
    const firstData = results.data[0];
    // Setting dateEntered state with the value of enteredOn
    setDateEntered(firstData.enteredOn);
    if (results.success) {
      const payload = results.data.reduce((acc, curr) => {
        const partyName = curr.party?.partyName ?? "N/A";
        return [
          ...acc,
          {
            id: curr.id,
            dateEntered: curr.enteredOn,
            shift: curr.shift,
            partyId: Number(curr.partyId),
            description: curr.description,
            invoiceNumber: curr.invoiceNo,
            glCode: Number(curr.generalLedgerCode),
            glDescription: curr.chartOfAccount.description,
            credit: Number(curr.credit),
            debit: Number(curr.debit),
            cheque: curr.cheqNumber,
            partyName: partyName,
            voucher: Number(curr.voucherNumber),
            transactionIdInc: Number(curr.transactionId),
            ledgerCodes: state.ledgerCodes,
            parties: state.parties,
          },
        ];
      }, []);
      setItemsQueue(payload);
      setDateEntered(results.data[0].enteredOn);
      setVoucher(results.data[0].voucherNumber);
      setShift(results.data[0].shift);
      setTypeLast(EMeters.LAST);
      console.log(itemsQueue, "dsiiiiii");

      // setEditpopup(false);
      // setType("EDIT");
    } else {
      message.error(results.message);
    }
  };

  const ascVoucher = async () => {
    const results = await ascBank(access_token);
    console.log(results, "ressaaaaa");
    if (results.success) {
      const firstData = results.data[0];
      // Setting dateEntered state with the value of enteredOn
      setDateEntered(firstData.enteredOn);
      const payload = results.data.reduce((acc, curr) => {
        const partyName = curr.party?.partyName ?? "N/A";
        return [
          ...acc,
          {
            id: curr.id,
            dateEntered: curr.enteredOn,
            shift: curr.shift,
            partyId: Number(curr.partyId),
            description: curr.description,
            invoiceNumber: curr.invoiceNo,
            glCode: Number(curr.generalLedgerCode),
            credit: Number(curr.credit),
            debit: Number(curr.debit),
            cheque: curr.cheqNumber,
            voucher: curr.voucherNumber,
            glDescription: curr.chartOfAccount.description,
            partyName: partyName,
            transactionIdInc: Number(curr.transactionId),
            ledgerCodes: state.ledgerCodes,
            parties: state.parties,
          },
        ];
      }, []);
      setItemsQueue(payload);
      setDateEntered(results.data[0].enteredOn);
      setVoucher(results.data[0].voucherNumber);
      setShift(results.data[0].shift);
      setTypeLast(EMeters.LAST);

      // setEditpopup(false);
      // setType("EDIT");
    } else {
      message.error(results.message);
    }
  };

  const chkAlert = async () => {
    try {
      const getCurrentDate = () => {
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, "0");
        const day = String(currentDate.getDate()).padStart(2, "0");
        return `${year}/${month}/${day}`;
      };

      const getD = getCurrentDate();
      let data = {
        enteredOn: getD,
      };

      const results = await getAlert(data, access_token);

      if (Array.isArray(results.data)) {
        results.data.forEach((alert) => {
          const handleButtonClick = async () => {
            console.log(alert.id); // Replace with your desired action
            const results = await deleteSale(alert.id, access_token);
          };

          message.info({
            content: (
              <div>
                {` Amount Notification ${alert.description}, Amount: ${alert.amount}`}
                <Button
                  type="primary"
                  size="small"
                  onClick={handleButtonClick}
                  style={{ marginLeft: "10px" }}
                >
                  Delete
                </Button>
              </div>
            ),
            className: "custom-message",
          });
        });
      } else if (results.data) {
        const handleButtonClick = async () => {
          const results = await deleteSale(results.data.id, access_token);
        };

        message.info({
          content: (
            <div>
              {`${results.data.description}, ${results.data.amount}`}
              <Button
                type="primary"
                size="small"
                onClick={handleButtonClick}
                style={{ marginLeft: "10px" }}
              >
                Action
              </Button>
            </div>
          ),
          className: "custom-message",
        });
      }
    } catch (error) {
      console.error("Error fetching alert:", error);
    }
  };

  useEffect(() => {
    chkAlert();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onePreVoucher = async () => {
    let data = {
      voucherNumber: voucher,
    };
    const results = await onePreData(data, access_token);
    console.log(results, "ressaaaaa");
    if (results.success) {
      const firstData = results.data[0];
      // Setting dateEntered state with the value of enteredOn
      setDateEntered(firstData.enteredOn);
      const payload = results.data.reduce((acc, curr) => {
        const partyName = curr.party?.partyName ?? "N/A";
        return [
          ...acc,
          {
            id: curr.id,
            dateEntered: curr.enteredOn,
            shift: curr.shift,
            partyId: Number(curr.partyId),
            description: curr.description,
            invoiceNumber: curr.invoiceNo,
            glCode: Number(curr.generalLedgerCode),
            glDescription: curr.chartOfAccount.description,
            partyName: partyName,
            credit: Number(curr.credit),
            debit: Number(curr.debit),
            cheque: curr.cheqNumber,
            voucher: curr.voucherNumber,
            transactionIdInc: Number(curr.transactionId),
            ledgerCodes: state.ledgerCodes,
            parties: state.parties,
          },
        ];
      }, []);
      setItemsQueue(payload);
      setDateEntered(results.data[0].enteredOn);
      setVoucher(results.data[0].voucherNumber);
      setShift(results.data[0].shift);

      // setEditpopup(false);
      // setType("EDIT");
    } else {
      message.error(results.message);
    }
  };

  const oneNextVoucher = async () => {
    let data = {
      voucherNumber: voucher,
    };
    const results = await oneNextData(data, access_token);
    console.log(results, "ressaaaaa");
    if (results.success) {
      const firstData = results.data[0];
      // Setting dateEntered state with the value of enteredOn
      setDateEntered(firstData.enteredOn);
      const payload = results.data.reduce((acc, curr) => {
        const partyName = curr.party?.partyName ?? "N/A";
        return [
          ...acc,
          {
            id: curr.id,
            dateEntered: curr.enteredOn,
            shift: curr.shift,
            partyId: Number(curr.partyId),
            description: curr.description,
            invoiceNumber: curr.invoiceNo,
            glCode: Number(curr.generalLedgerCode),
            glDescription: curr.chartOfAccount.description,
            partyName: partyName,
            credit: Number(curr.credit),
            debit: Number(curr.debit),
            cheque: curr.cheqNumber,
            voucher: curr.voucherNumber,
            transactionIdInc: Number(curr.transactionId),
            ledgerCodes: state.ledgerCodes,
            parties: state.parties,
          },
        ];
      }, []);
      setItemsQueue(payload);
      setDateEntered(results.data[0].enteredOn);
      setVoucher(results.data[0].voucherNumber);
      setShift(results.data[0].shift);

      // setEditpopup(false);
      // setType("EDIT");
    } else {
      message.error(results.message);
    }
  };

  const editItem = async () => {
    const uniqueId = Date.now(); // Generate a unique ID for the entries

    const updatedUserEntry = {
      ...state,
      id: uniqueId,
      entryType: state.credit ? "credit" : "debit",
    };

    const updatedBankEntry = {
      ...state,
      id: uniqueId,
      partyId: "",
      partyName: "",
      invoiceNo: "",
      cheque: "",
      glCode: state.bankTransactionCode,
      entryType: state.credit ? "debit" : "credit",
    };

    if (state.debit) {
      updatedBankEntry.debit = "";
      updatedBankEntry.credit = state.debit;
    } else if (state.credit) {
      updatedBankEntry.credit = "";
      updatedBankEntry.debit = state.credit;
    }

    // Update the user entry
    itemsQueue[editedItem] = updatedUserEntry;

    // Find the corresponding bank entry
    const bankEntryIndex = itemsQueue.findIndex(
      (entry) =>
        entry.id === state.id && entry.glCode === state.bankTransactionCode
    );

    if (bankEntryIndex !== -1) {
      // Update the bank entry
      itemsQueue[bankEntryIndex] = updatedBankEntry;
    }

    setItemsQueue([...itemsQueue]);
    setEditedItem(null);
    clearState();
  };

  const deleteItem = (index) => {
    const deletedItem = itemsQueue[index];

    if (
      deletedItem.entryType === "debit" ||
      deletedItem.entryType === "credit"
    ) {
      const uniqueIdentifier = deletedItem.id;

      // Find the user entry and corresponding bank entry by unique identifier
      const entriesToDelete = itemsQueue.filter(
        (entry) =>
          (entry.id === deletedItem.id &&
            entry.entryType === deletedItem.entryType) ||
          (entry.id === deletedItem.id &&
            entry.entryType !== deletedItem.entryType &&
            entry.id === uniqueIdentifier)
      );

      // Remove the entries from the itemsQueue
      entriesToDelete.forEach((entryToDelete) => {
        const entryIndex = itemsQueue.indexOf(entryToDelete);
        if (entryIndex !== -1) {
          itemsQueue.splice(entryIndex, 1);
        }
      });
    } else {
      itemsQueue.splice(index, 1);
    }

    setItemsQueue([...itemsQueue]);
    setEditedItem(null);
    clearState();
  };

  const getLatestDate = async () => {
    const _date = await latestDate(access_token);
    setDateEntered(_date.data.enteredOn);
    setShift(_date.data.shift);
    // console.log(_date, "Dateee");
  };
  useEffect(() => {
    getLatestDate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ---------------------- EDIT API ------------------

  const [editPopup, setEditpopup] = useState(false);
  const edit = () => {
    setEditpopup(true);
  };

  const editHandler = async () => {
    if (!voucher) return message.error("Please type voucher number!");
    const results = await getData(voucher, access_token);
    if (results.success) {
      console.log(results, "ressaaaaa");
      const firstData = results.data[0];
      // Setting dateEntered state with the value of enteredOn
      setDateEntered(firstData.enteredOn);
      const payload = results.data.reduce((acc, curr) => {
        return [
          ...acc,
          {
            id: curr.id,
            dateEntered: curr.enteredOn,
            shift: curr.shift,
            partyId: Number(curr.partyId),
            description: curr.description,
            invoiceNumber: curr.invoiceNo,
            bankTransactionCode: state.bankTransactionCode,
            bankTransactionDesc: state.bankTransactionDesc,
            bankTransactionOldCode: state.bankTransactionOldCode,
            glDescription: curr.chartOfAccount.description,
            glCode: Number(curr.generalLedgerCode),
            credit: Number(curr.credit),
            debit: Number(curr.debit),
            cheque: curr.cheqNumber,
            transactionIdInc: Number(curr.transactionId),
            ledgerCodes: state.ledgerCodes,
            allBank: state.allBank,
            parties: state.parties,
          },
        ];
      }, []);
      setItemsQueue(payload);
      setEditpopup(false);
      setType("EDIT");
    } else {
      message.error(results.message);
    }
  };

  // -------- single

  const [modal, contextHolder] = Modal.useModal();
  const deleteSinglePurchase = async (transactionIdInc) => {
    console.log("deleteSingle");
    const results = await deleteSingleReceipt(transactionIdInc, access_token);
    if (results.success) {
      if (itemsQueue.length !== 1) {
        await editHandler();
      } else {
        setItemsQueue([]);
      }
      message.success("Record Deleted Successfully !");
      // clearStates()
    } else {
      message.error(results.message);
    }
  };

  const confirmDelete = (transactionIdInc) => {
    modal.confirm({
      title: `Confirm`,
      content: "Are you sure you want to delete this Record?",
      okText: "Delete",
      cancelText: "Cancel",
      onOk: () => deleteSinglePurchase(transactionIdInc),
    });
  };

  // -------- whole data

  const [deletePopup, setDeletepopup] = useState(false);
  const deletePurchase = () => {
    setDeletepopup(true);
  };

  const deletePurchaseHandler = async () => {
    const results = await deleteReceipt(voucher, access_token);
    if (results.success) {
      clearStates();
      message.success("Record Deleted Successfully !");
      clearStates();
      setDeletepopup(false);
    } else {
      message.error(results.message);
    }
  };
  const confirmDeleteAll = () => {
    modal.confirm({
      title: `Confirm`,
      content: "Are you sure you want to delete this Voucher?",
      okText: "Delete",
      cancelText: "Cancel",
      onOk: () => deletePurchaseHandler(),
    });
  };
  console.log(state, "state");

  const inputRefs = {};
  const addInputFieldRef = (ref, fieldName) => {
    if (ref && fieldName) {
      inputRefs[fieldName] = ref;
    }
  };
  const handleEnterKey = (e, fieldName) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent default behavior of the "Enter" key

      // Trigger addItem function if the current field is "amount"
      if (fieldName === "debit" && state.debit.trim() !== "") {
        Boolean(editedItem != null) ? editItem() : addItem();
      } else if (fieldName === "credit" && state.credit.trim() !== "") {
        Boolean(editedItem != null) ? editItem() : addItem();
      } else {
        const currentFieldName = fieldName;

        // Define the order of input fields
        const fieldOrder = [
          "dateEntered",
          "shift",
          "accountName",
          "glCode",
          "description",
          "invoiceNo",
          "cheque",
          "debit",
          "credit",
          // Add more field names as needed
        ];

        // Find the index of the current field in the order array
        const currentIndex = fieldOrder.indexOf(currentFieldName);
        console.log(currentIndex, "current Inddd");
        if (currentIndex !== -1 && currentIndex < fieldOrder.length - 1) {
          // Move focus to the next input field
          const nextFieldName = fieldOrder[currentIndex + 1];
          const nextInput = inputRefs[nextFieldName];

          if (nextInput) {
            nextInput.focus();
          }
        }
      }
    }
  };

  const menu = (index) => {
    return (
      <Menu>
        {type === "SAVE" ? (
          <Menu.Item key="0">
            <button
              onClick={() => {
                setFieldsShow(true);
                setEditedItem(index);
                setState(itemsQueue[index]);
                console.log(itemsQueue, "edit");
              }}
            >
              Edit
            </button>
          </Menu.Item>
        ) : (
          <></>
        )}
        {type === "SAVE" ? (
          <Menu.Item key="1">
            <button
              onClick={() => {
                deleteItem(index);
              }}
            >
              {" "}
              Delete
            </button>
          </Menu.Item>
        ) : (
          <Menu.Item key="1">
            <button
              onClick={() => {
                confirmDelete(itemsQueue[index].transactionIdInc);
              }}
            >
              {" "}
              Delete
            </button>
          </Menu.Item>
        )}
      </Menu>
    );
  };
  return (
    <div className="flex  bg-black main">
      <SideBar />
      <div className="h-full  flex flex-col content-center  w-full">
        <div className="meterTableMain ml-10 mt-5 mr-10">
          {contextHolder}
          <div className="bg-blue-500 headingBox flex justify-between">
            <h3 className=" text-white tableHeading pl-10">
              BANK VOUCHER ENTRY
            </h3>
          </div>
          <div className="bg-blue-500">
            <div className="flex content-center pt-5">
              <input
                readOnly
                value={voucher}
                className="inpTxt inpTxtVoucher p-2 h-8 ml-11 mb-3 w-40"
              />
              <input
                type="date"
                value={dateEntered}
                className="text-black inpTxt p-2 h-8 ml-3 mb-3"
                onChange={(e) => setDateEntered(e.target.value)}
                onKeyDown={(e) => handleEnterKey(e, "dateEntered")}
                ref={(ref) => addInputFieldRef(ref, "dateEntered")}
              />
              <input
                type="number"
                name="shift"
                value={shift}
                placeholder="Shift"
                className=" text-black inpTxt p-1 h-8 ml-3 w-28"
                onChange={(e) => setShift(e.target.value)}
                onKeyDown={(e) => handleEnterKey(e, "shift")}
                ref={(ref) => addInputFieldRef(ref, "shift")}
              />
              {fieldsShow && (
                <>
                  <Select
                    showSearch
                    name="accountNumber"
                    placeholder="A/C No."
                    className="ant-select  bg-black text-white  inpTxt p-1 h-9 ml-3 w-52"
                    optionFilterProp="children"
                    value={state.partyId || "A/C No."}
                    onChange={(e) => {
                      console.log("e", e);

                      const _party = state.parties.find(
                        (el) => el.partyId === e
                      );
                      if (_party) {
                        setState({
                          ...state,
                          partyId: e,
                          partyName: _party.PartyName,
                          glCode: _party.chartOfAccount.generalLedgerCode,
                          glDescription: _party.chartOfAccount.description,
                        });
                      } else {
                        setState({
                          ...state,
                          partyId: e,
                          partyName: "",
                          glCode: "",
                          glDescription: "",
                        });
                      }
                    }}
                    onKeyDown={(e) => handleEnterKey(e, "accountName")}
                    ref={(ref) => addInputFieldRef(ref, "accountName")}
                  >
                    <Option value={0}>None</Option>
                    {state.parties.map((el) => (
                      <Option
                        className="w-auto"
                        value={el.partyId}
                      >{`${el.partyId} - ${el.PartyName}`}</Option>
                    ))}
                  </Select>
                  {/* <Select
                    showSearch
                    className="ml-3"
                    placeholder="Credit GL Code"
                    optionFilterProp="children"
                    value={state.glCode || "Credit GL Code"}
                    onChange={(e) => {
                      const lCode = state.ledgerCodes.find(
                        (el) => el.generalLedgerCode === e
                      );
                      setState({
                        ...state,
                        glCode: e,
                        glDescription: lCode.description,
                      });
                    }}
                  >
                    {state.ledgerCodes.map((el) => (
                      <Option value={el.generalLedgerCode}>
                        {el.generalLedgerCode}
                      </Option>
                    ))}
                  </Select> */}
                  {/* <Select
                    showSearch
                    className="ml-3"
                    placeholder="GL Description"
                    optionFilterProp="children"
                    value={state.glDescription || "GL Description "}
                    onChange={(e) => {
                      const lCode = state.ledgerCodes.find(
                        (el) => el.generalLedgerCode === e
                      );
                      setState({
                        ...state,
                        glCode: e,
                        glDescription: lCode.description,
                      });
                    }}
                  >
                    {state.ledgerCodes.map((el) => (
                      <Option value={el.generalLedgerCode}>
                        {el.description}
                      </Option>
                    ))}
                  </Select> */}
                  <Select
                    // hidden
                    showSearch
                    className="ant-select  bg-black text-white  inpTxt p-1 h-9 ml-3 w-52"
                    placeholder="Bank GL Code"
                    optionFilterProp="children"
                    value={state.bankTransactionCode || "Bank GL Code"}
                    onChange={(e) => {
                      const lCode = state.allBank.find(
                        (el) => el.generalLedgerCode === e
                      );
                      setState({
                        ...state,
                        bankTransactionCode: e,
                        bankTransactionDesc: lCode.description,
                      });
                    }}
                  >
                    {state.allBank.map((el) => (
                      <Option value={el.generalLedgerCode}>
                        {el.generalLedgerCode}
                      </Option>
                    ))}
                  </Select>
                  <Select
                    showSearch
                    className="ant-select  bg-black text-white  inpTxt p-1 h-9 ml-3 w-52"
                    placeholder="Bank Description"
                    optionFilterProp="children"
                    value={state.bankTransactionDesc || "Bank Description "}
                    onChange={(e) => {
                      console.log("e", e);
                      const lCode = state.allBank.find(
                        (el) => el.generalLedgerCode === e
                      );
                      console.log("e", lCode);

                      setState({
                        ...state,
                        bankTransactionCode: e,
                        bankTransactionDesc: lCode.description,
                      });
                    }}
                  >
                    {state.allBank.map((el) => (
                      <Option value={el.generalLedgerCode}>
                        {el.description}
                      </Option>
                    ))}
                  </Select>
                </>
              )}
            </div>
          </div>
          {fieldsShow && (
            <div className="">
              <div className="flex content-center flex-wrap pt-5">
                <div className="">
                  <Select
                    showSearch
                    disabled={Boolean(state.partyId)}
                    name="glCode"
                    className="ant-select ant-select bg-black text-white ml-10  inpTxt  p-1 h-9  w-64"
                    placeholder="Credit GL Code"
                    optionFilterProp="children"
                    value={state.glCode || "Credit GL Code"}
                    onChange={(e) => {
                      const lCode = state.ledgerCodes.find(
                        (el) => el.generalLedgerCode === e
                      );
                      setState({
                        ...state,
                        glCode: e,
                        glDescription: lCode.description,
                      });
                    }}
                    onKeyDown={(e) => handleEnterKey(e, "glCode")}
                    ref={(ref) => addInputFieldRef(ref, "glCode")}
                  >
                    {state.ledgerCodes.map((el) => (
                      <Option value={el.generalLedgerCode}>
                        {el.generalLedgerCode} - {el.description}
                      </Option>
                    ))}
                  </Select>
                </div>
                <input
                  type="text"
                  name="description"
                  value={state.description}
                  onChange={onChangeText}
                  placeholder="Description"
                  className=" ant-select  bg-black text-white  inpTxt   p-1 h-9 ml-3 w-52"
                  onKeyDown={(e) => handleEnterKey(e, "description")}
                  ref={(ref) => addInputFieldRef(ref, "description")}
                />
                <input
                  type="text"
                  name="invoiceNo"
                  value={state.invoiceNo}
                  onChange={onChangeText}
                  placeholder="Invoice No"
                  className="ant-select  bg-black text-white  inpTxt   p-1 h-9 ml-3 w-20"
                  onKeyDown={(e) => handleEnterKey(e, "invoiceNo")}
                  ref={(ref) => addInputFieldRef(ref, "invoiceNo")}
                />
                <input
                  type="text"
                  name="cheque"
                  value={state.cheque}
                  onChange={onChangeText}
                  placeholder="Chq/DD"
                  className="ant-select  bg-black text-white  inpTxt   p-1 h-9 ml-3 w-20"
                  onKeyDown={(e) => handleEnterKey(e, "cheque")}
                  ref={(ref) => addInputFieldRef(ref, "cheque")}
                />

                <input
                  type="number"
                  name="debit"
                  disabled={Boolean(state.credit)}
                  value={state.debit}
                  onChange={onChangeText}
                  placeholder="Debit"
                  className="ant-select  bg-black text-white  inpTxt  p-1 h-9 ml-3 w-36"
                  onKeyDown={(e) => handleEnterKey(e, "debit")}
                  ref={(ref) => addInputFieldRef(ref, "debit")}
                />
                <input
                  type="number"
                  name="credit"
                  disabled={Boolean(state.debit)}
                  value={state.credit}
                  onChange={onChangeText}
                  placeholder="Credit"
                  className="ant-select  bg-black text-white  inpTxt  p-1 h-9 ml-3 w-36"
                  onKeyDown={(e) => handleEnterKey(e, "credit")}
                  ref={(ref) => addInputFieldRef(ref, "credit")}
                />
                {Boolean(editedItem != null) ? (
                  <button
                    onClick={editItem}
                    className="bg-blue-500 hover:bg-blue-700 text-white  ml-3 py-1 px-4 rounded"
                  >
                    EDIT
                  </button>
                ) : (
                  <button
                    onClick={addItem}
                    className="bg-blue-500 hover:bg-blue-700 text-white  ml-3 py-1 px-4 rounded"
                  >
                    ADD +
                  </button>
                )}
              </div>
            </div>
          )}

          <div className="div">
            <div className="">
              <div
                style={{ overflow: "auto", maxHeight: "400px" }}
                className="overflow-scroll   shadow-md sm:rounded-lg tableDiv p-5 pl-10  w-full"
              >
                <table className="w-full overflow-scroll text-sm text-left text-gray-500 dark:text-gray-400">
                  <thead className="bg-blue-500 text-white uppercase dark:bg-gray-700 tableHeading  dark:text-gray-400">
                    <tr>
                      <th
                        className="pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium "
                        scope="col"
                      >
                        SNo.
                      </th>
                      <th
                        className="  pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium "
                        scope="col"
                      >
                        GL CODE
                      </th>
                      <th
                        className="  pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium "
                        scope="col"
                      >
                        GL DESCRIPTION
                      </th>
                      <th
                        className="  pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium "
                        scope="col"
                      >
                        Party
                      </th>

                      <th
                        className="  pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium "
                        scope="col"
                      >
                        DESCRIPTION
                      </th>
                      <th
                        className="  pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium "
                        scope="col"
                      >
                        Invoice
                      </th>

                      <th
                        className="  pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium "
                        scope="col"
                      >
                        Cheque/DD
                      </th>
                      <th
                        className="  pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium "
                        scope="col"
                      >
                        Debit / Paid
                      </th>
                      <th
                        className="  pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium "
                        scope="col"
                      >
                        Credit / Rcvd
                      </th>
                      <th
                        className="  pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium "
                        scope="col"
                      >
                        ACTION
                      </th>
                    </tr>
                  </thead>
                  <tbody className="tableBody">
                    {itemsQueue.map((ele, i) => {
                      return (
                        <tr key={i} className="tbodyData text-white">
                          <td className="pt-3 pb-3  pl-2 pr-1   font-medium   ">
                            <p className="fontSize">{i + 1}</p>
                          </td>
                          <td className="pt-3 pb-3  pl-2 pr-1   font-medium   ">
                            <p className="fontSize">{ele.glCode}</p>
                          </td>{" "}
                          <td className="pt-3 pb-3  pl-2 pr-1   font-medium   ">
                            <p className="font-medium">{ele.glDescription}</p>
                          </td>
                          <td className="pt-3 pb-3  pl-2 pr-1   font-medium   ">
                            <p className="fontSize">{ele.partyId}</p>
                          </td>
                          <td className="pt-3 pb-3  pl-2 pr-1   font-medium   ">
                            <p className="fontSize">{ele.description}</p>
                          </td>
                          <td className="pt-3 pb-3  pl-2 pr-1   font-medium   ">
                            <p className="fontSize">{ele.invoiceNo}</p>
                          </td>
                          <td className="pt-3 pb-3  pl-2 pr-1   font-medium   ">
                            <p className="fontSize">{ele.cheque}</p>
                          </td>
                          <td className="pt-3 pb-3  pl-2 pr-1   font-medium   ">
                            <p
                              className={`fontSize ${
                                ele.entryType === "debit" ? "debit" : "credit"
                              }`}
                            >
                              {ele.debit}
                            </p>
                          </td>
                          <td className="pt-3 pb-3  pl-2 pr-1   font-medium   ">
                            <p
                              className={`fontSize ${
                                ele.entryType === "credit" ? "credit" : "debit"
                              }`}
                            >
                              {ele.credit}
                            </p>
                          </td>
                          <td className="pt-3 pb-3  pl-2 pr-1   font-medium   ">
                            <Dropdown overlay={menu(i)} placement="bottomLeft">
                              <Button>Action</Button>
                            </Dropdown>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                <div className="flex justify-end">
                  <input
                    type="text"
                    readOnly
                    placeholder=""
                    name=""
                    id=""
                    value={debitTotal}
                    className="mt-2 mr-10 pl-10 pt-1 pb-1 w-32 bg-black text-white outline-none"
                  />
                  <input
                    type="text"
                    readOnly
                    placeholder=""
                    name=""
                    id=""
                    value={creditTotal}
                    className="mt-2 pl-10 pt-1 pb-1 w-32 bg-black text-white outline-none"
                  />
                </div>
              </div>
              <div className="flex justify-evenly pb-2">
                <div>
                  {type === "ADD" && (
                    <button
                      onClick={addVoucher}
                      className="bg-blue-500 hover:bg-blue-700 text-white mt-3 py-1 px-4 rounded"
                    >
                      Add
                    </button>
                  )}

                  {type === "SAVE" && (
                    <button
                      onClick={save}
                      className={`bg-blue-500 hover:bg-blue-700 flex h-9 text-white mt-3 py-1 px-4 rounded ${
                        isButtonDisabled ? "opacity-50 cursor-not-allowed" : ""
                      }`}
                      disabled={isButtonDisabled}
                      // className="bg-blue-500 hover:bg-blue-700 text-white mt-3 py-1 px-4 rounded"
                    >
                      Save
                    </button>
                  )}

                  {type === "ADD" && (
                    <button
                      onClick={edit}
                      className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-3 py-1 px-4 rounded"
                    >
                      Edit
                    </button>
                  )}

                  <button
                    onClick={() => deletePurchase()}
                    className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-3 py-1 px-4 rounded"
                    disabled={type !== "ADD"}
                  >
                    Delete
                  </button>
                  <button
                    onClick={() => {
                      clearStates();
                    }}
                    className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-3 py-1 px-4 rounded"
                  >
                    {type === "EDIT" ? "Done" : "Exit"}
                  </button>
                </div>
                <div className="flex content-end mt-3 bg-white justify-end"></div>

                <div className="pr-5">
                  <button
                    onClick={ascVoucher}
                    className="bg-blue-500 hover:bg-blue-700 text-white mt-3 py-1 px-4 rounded"
                  >
                    <img src={`./img/first.png`} alt="" />
                  </button>
                  {typeLast === "LAST" && (
                    <button
                      onClick={onePreVoucher}
                      className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-3 py-1 px-4 rounded"
                    >
                      <img src={`./img/previous.png`} alt="" />
                    </button>
                  )}
                  {typeLast === "LAST" && (
                    <button
                      onClick={oneNextVoucher}
                      className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-3 py-1 px-4 rounded"
                    >
                      <img src={`./img/next.png`} alt="" />
                    </button>
                  )}
                  <button
                    onClick={descVoucher}
                    className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-3 py-1 px-4 rounded"
                  >
                    <img src={`./img/latest.png`} alt="" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Popup popup={editPopup} handlePopup={setEditpopup} onOk={editHandler}>
        <div>
          <h2>Please type voucher number</h2>
          <input
            style={{
              border: "1px solid",
            }}
            autoFocus
            type="number"
            value={voucher}
            onChange={(e) => setVoucher(e.target.value)}
          />
        </div>
      </Popup>

      <Popup
        popup={deletePopup}
        handlePopup={setDeletepopup}
        onOk={confirmDeleteAll}
      >
        <div>
          <h2>Please type voucher number for delete record</h2>
          <input
            style={{
              border: "1px solid",
            }}
            autoFocus
            type="number"
            value={voucher}
            onChange={(e) => setVoucher(e.target.value)}
          />
        </div>
      </Popup>
    </div>
  );
};

export default BankVoucher;
